import { Directive, HostBinding, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[imageLoader]'
})
export class ImageLoaderDirective {

  @Input('src') imageSrc;
  @HostListener('load')
  loadImage() {
    this.srcAttr = this.imageSrc;
  }

  @HostBinding('attr.src') srcAttr = "../../../assets/images/loading.svg"
  constructor() { }
}

